import request from "@/utils/request"


export function verifyToken(token, username) {
    return request({
        url: "/admin/sso/verifyToken",
        method: "GET",
        params: {
            token: token || '',
            username: username || ''
        }
    })
}
